import { Injectable } from '@angular/core';
import { Geolocation } from '../models/geolocation';

@Injectable()
export class GeolocationService {
    constructor() { }

    private readonly geolocationConfig = {
        enableHighAccuracy: true,
    };

    getCurrentLocation(): Promise<Geolocation | any> {
        const p = new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    resolve({
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                        accuracy: position.coords.accuracy,
                        speed: position.coords.speed
                    } as Geolocation);
                }, (err) => {
                    reject(err)
                }, this.geolocationConfig);
            } else {
                reject(new Error('Geolocation is not supported by this browser.'));
            }
        });
        return p;
    }
}